import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import ContentCategories from './ContentCategories';
import { hasContentCategoriesPermission } from './helpers/hasContentCategoriesPermission.helper';

import type { ValidationError } from 'sonata-react-components';
import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  baseCurrency: BaseCurrencyInterface;
  error?: ValidationError;
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  totalBudget: number;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function ContentCategoriesWrapper({ baseCurrency, error, onChange, targeting, totalBudget, user, userRoles }: Props) {
  if (!hasContentCategoriesPermission(user, userRoles)) {
    return null;
  }
  return (
    <TargetingProvider onChange={onChange} targeting={targeting} user={user} userRoles={userRoles}>
      <ContentCategories baseCurrency={baseCurrency} error={error} totalBudget={totalBudget} />
    </TargetingProvider>
  );
}

export default ContentCategoriesWrapper;
